module.exports = __webpack_public_path__ + "images/Big_run_logo-e52ee53555d12d83d30f9faf0d3995cf.png";